// extracted by mini-css-extract-plugin
export default {"container":"Nav_container__qwsxB","list":"Nav_list__YDXDw","item":"Nav_item__7NKhV","item_link":"Nav_item_link__9sIrS"};